(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faq-section"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('faq-item')) {
    customElements.define(
      'faq-item',
      class FAQItem extends HTMLElement {
        constructor() {
          super();
        }
        connectedCallback() {
          this.categoryElement = document.querySelector(`.faq-category#${this.dataset.catId}`);
        }
      }
    );
  }
  if (!customElements.get('faq-section')) {
    customElements.define(
      'faq-section',
      class FAQSection extends HTMLElement {
        constructor() {
          super();
          this.activeClass = 'active';
        }

        connectedCallback() {
          this.initElements();
          this.bindEvents();
          this.activateDefaultCategory();
        }

        initElements() {
          this.categories = this.querySelector('.faq-categories');
          this.answers = this.querySelector('.faq-answers');
        }

        bindEvents() {
          this.categories.addEventListener('click', (e) => {
            const category = e.target.closest('.faq-category');
            if (category) this.switchCategory(category);
          });

          this.answers.addEventListener('click', (e) => {
            const question = e.target.closest('.faq-question');
            if (question) question.classList.toggle(this.activeClass);
          });
        }

        switchCategory(category) {
          if (!category) return;

          this.categories
            .querySelectorAll('.faq-category')
            .forEach((cat) => cat.classList.toggle(this.activeClass, cat === category));

          const categoryId = category.id;
          this.answers
            .querySelectorAll('.faq-item')
            .forEach((item) => item.classList.toggle(this.activeClass, item.dataset.catId === categoryId));
        }

        activateDefaultCategory() {
          const firstCategory = this.categories.querySelector('.faq-category');
          if (firstCategory) this.switchCategory(firstCategory);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stan-sticky-products"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const section = document.getElementById(
      'StanProducts'
    );

    if (!section) return;

    const signupButton = section.querySelector(
      '[data-stan-signup]'
    );

    if (!signupButton) return;

    signupButton.addEventListener('click', () => {
      window._klOnsite = window._klOnsite || [];
      window._klOnsite.push(['openForm', 'VTCd2B']);
    });

  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["store-locations"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const locationSelected = document.querySelector('.store-locator-container .location-selected');
    const dropdown = document.querySelector('.store-locator-dropdown');

    if (locationSelected && dropdown) {
      locationSelected.addEventListener('click', function () {
        dropdown.classList.toggle('active');
      });
    }
  });
  function openDirections(destination) {
    const destinationUri = encodeURIComponent(destination);
    window.open(`https://www.google.com/maps/dir/?api=1&destination=${destinationUri}`, '_blank');
  }

  function initStoreLocator({
    container = document.querySelector('.store-locator-container'),
    form = document.getElementById('store-location-form'),
    dropdown = document.querySelector('.store-locator-dropdown'),
  } = {}) {
    if (!container) return () => {};
    const directionInput = document.getElementById('locator-map-guide');
    directionInput.direction = directionInput.dataset.direction;
    directionInput.addEventListener('click', () => {
      const direction = directionInput.direction;
      openDirections(direction);
    });

    const onClick = (e) => {
      const item = e.target.closest('.store-locator-item');
      if (!item || !container.contains(item)) return;

      const isGoogleMap = !!(form && form.dataset.googleMap === 'true');

      const selected = container.querySelector('.location-selected');
      if (selected) {
        // Replace selected content safely (no innerHTML)
        const clone = item.cloneNode(true);
        // If you don't want the wrapper class copied, you can copy children only:
        selected.replaceChildren(...Array.from(clone.childNodes));
      }

      if (dropdown) {
        dropdown.classList.remove('active');
      }

      const srcHolder = item.matches('[data-src]') ? item : item.querySelector('[data-src]');
      const labelHolder = item.matches('[data-label]') ? item : item.querySelector('[data-label]');
      const input = document.getElementById(srcHolder?.htmlFor);
      if (directionInput) {
        directionInput.direction = input?.value;
      }

      if (isGoogleMap) {
        if (form) setTimeout(() => form.submit(), 300);
        return;
      }

      const image = document.querySelector('.contact-address-container--location .location-image');
      const src = srcHolder ? srcHolder.dataset.src : undefined;
      const label = labelHolder ? labelHolder.dataset.label : undefined;

      if (image && src) {
        image.srcset = src;
      }
      if(directionInput){
        const text = directionInput.querySelector('.direction-text')
        if(text){
          text.innerText = label
        }
      }
    };

    container.addEventListener('click', onClick);
  }
  initStoreLocator();

  } catch(e) { console.error(e); }
})();
})();
